import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { ComponentSize } from '../../declarations/common.decl';
import { FormItemStatus } from '../Form';
import { useFormContext, useFormItemContext } from '../Form/context';
import { CloseOutlined, Icon } from '../Icon';
import { IconButton } from '../IconButton';
import { shouldForwardProp, makeTextFieldInputSize, makeTextFieldVariant, makeTextFieldValidationStatus } from './utils';
var TextFieldInputComponent = styled.input.withConfig({
  displayName: "TextFieldInput__TextFieldInputComponent",
  componentId: "sc-1y2grzu-0"
})(["", " ", ""], makeTextFieldVariant, makeTextFieldValidationStatus);
var TextFieldClearButton = styled(IconButton).withConfig({
  displayName: "TextFieldInput__TextFieldClearButton",
  componentId: "sc-1y2grzu-1"
})(["position:absolute;top:50%;right:16px;background-color:transparent;border:none;transform:translateY(-50%);"]);
var IconComponent = styled(Icon).withConfig({
  displayName: "TextFieldInput__IconComponent",
  componentId: "sc-1y2grzu-2"
})(["position:absolute;top:50%;left:16px;transform:translateY(-50%);"]);
var TextFieldInputContainer = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "TextFieldInput__TextFieldInputContainer",
  componentId: "sc-1y2grzu-3"
})(["position:relative;> ", "{", ";}> ", "{pointer-events:none;}"], TextFieldInputComponent, makeTextFieldInputSize, IconComponent);
var TextFieldInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var size = _ref.size,
      validationStatus = _ref.validationStatus,
      onClear = _ref.onClear,
      icon = _ref.icon,
      id = _ref.id,
      otherInputProps = _objectWithoutPropertiesLoose(_ref, ["size", "validationStatus", "onClear", "icon", "id"]);

  var formContext = useFormContext();
  var formItemContext = useFormItemContext();
  var inputSize = size || (formContext == null ? void 0 : formContext.size) || ComponentSize.REGULAR;
  var inputStatus = validationStatus || (formItemContext == null ? void 0 : formItemContext.validationStatus);
  var inputId = id || (formItemContext == null ? void 0 : formItemContext.name);
  var error = inputStatus === FormItemStatus.ERROR;
  return /*#__PURE__*/React.createElement(TextFieldInputContainer, {
    size: inputSize
  }, icon && /*#__PURE__*/React.createElement(IconComponent, {
    component: icon
  }), /*#__PURE__*/React.createElement(TextFieldInputComponent, _extends({
    ref: ref,
    id: inputId,
    icon: !!icon,
    validationStatus: inputStatus
  }, otherInputProps)), !!onClear && /*#__PURE__*/React.createElement(TextFieldClearButton, {
    size: 16,
    component: CloseOutlined,
    onClick: onClear,
    color: error ? 'red.base' : undefined
  }));
});
TextFieldInput.defaultProps = {
  variant: 'input'
};
export default TextFieldInput;